import { isApiError } from '@/services/api';

const MAX_VIN_VRM_SEARCH_RETRIES = 1;
const BAD_GATEWAY = 502;

export const isRetryableVinVrmSearchError = (error: unknown): boolean => {
    if (!isApiError(error)) {
        return false;
    }
    if (error.status === undefined) {
        return true;
    }
    return error.status >= 500 && error.status !== BAD_GATEWAY;
};

export const shouldRetryVinVrmSearch = (failureCount: number, error: unknown): boolean =>
    failureCount < MAX_VIN_VRM_SEARCH_RETRIES && isRetryableVinVrmSearchError(error);
